export default __webpack_public_path__ + "static/covid-shot-a472374ff145842652845cfd8b1f2872.png";